const t = {
  name: "PrinterFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 1H5V6H4C2.34772 6 1 7.34772 1 9V16C1 17.6523 2.34772 19 4 19H5V23H19V19H20C21.6523 19 23 17.6523 23 16V9C23 7.34772 21.6523 6 20 6H19V1ZM17 21H7V16H17V21ZM17 6H7V3H17V6ZM19.25 11C19.25 11.69 18.69 12.25 18 12.25C17.31 12.25 16.75 11.69 16.75 11C16.75 10.31 17.31 9.75 18 9.75C18.69 9.75 19.25 10.31 19.25 11Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as PrinterFilled
};
